import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import thietlapthuchanhService from "services/hrm/thietlapthuchanhService";

export const create = createAsyncThunk(
  "thietlapthuchanhSlice/create",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess}= data
      const response = await thietlapthuchanhService.create(data);
      if(onSuccess)onSuccess(response.data)
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const getbyid = createAsyncThunk(
  "thietlapthuchanhSlice/getbyid",
  async (id, { rejectWithValue }) => {
    try {
      const response = await thietlapthuchanhService.getbyid(id);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


const initialState = {
  loading: false,
  thietlapthuchanhList: [],
  thietlapthuchanhListDetail:{},

};

const thietlapthuchanhSlice = createSlice({
  name: "thietlapthuchanhSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(create.pending, (state) => {
        state.loading = true;
      })
      .addCase(create.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(create.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getbyid.pending, (state) => {
        state.loading = true;
      })
      .addCase(getbyid.fulfilled, (state, action) => {
        state.loading = false;
        state.thietlapthuchanhListDetail = action.payload;
      })
      .addCase(getbyid.rejected, (state) => {
        state.loading = false;
      })
      
  
      
      ;
  },
});
// eslint-disable-next-line no-empty-pattern
export const {} = thietlapthuchanhSlice.actions;

export default thietlapthuchanhSlice.reducer;
